module.exports = __webpack_public_path__ + "img/emotional.3ef27632.svg";